var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hasFile,
              expression: "!hasFile",
            },
          ],
        },
        [
          _c("Input", {
            attrs: {
              placeholder: _vm.$t("audio.tip1"),
              size: "large",
              readonly: "",
            },
          }),
          _c("input", {
            staticClass: "input-box",
            attrs: { id: _vm.inputId, accept: ".wav", type: "file" },
            on: {
              change: function ($event) {
                return _vm.showFile($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "Row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasFile,
              expression: "hasFile",
            },
          ],
          attrs: { gutter: "20" },
        },
        [
          _c("i-col", { attrs: { span: "22" } }, [
            _c("span", { staticClass: "file-name" }, [
              _vm._v(_vm._s(_vm.uploadTip)),
            ]),
          ]),
          _c(
            "i-col",
            { attrs: { span: "2" } },
            [
              _c("Button", {
                attrs: { type: "error", ghost: "", icon: "md-trash" },
                on: { click: _vm.handleDelFile },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }